import {Pipe, PipeTransform} from '@angular/core';
import {JourSemaine} from '../enums/client/jour-semaine.enum';

@Pipe({name: 'jourSemaineList'})
export class JourSemaineListPipe implements PipeTransform {
  transform(jours: (JourSemaine | string)[]): string {
    return (jours ?? [])
      .map(j => typeof j === 'number' ? JourSemaine[j] : j)
      .join(', ');
  }
}
